import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"

import '@/pages/profile/sections/common.css'

export default function RegistrationNumber(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <div className='commonCon1'>
                <ul className='list-disc list-inside'>
                    {profile.bssSection.notes.n1.map((n: string, index: number) => (
                        <li key={index}>{n}</li>
                    ))}
                </ul>
            </div>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <p className='commonH4'>
                {profile.fields.registrationNumber}
                <span className='text-[#FF2828]'>*</span>
            </p>


            <InputBox
                id={listOfSections.registrationNumber}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.registrationNumber)}
                value={props.value}
                placeholder={profile.placeHolders.registrationNumber}
                showAsterisk={true}
            />


            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.registrationNumber)}
                />
            </div>
        </div>
    );
}
